import React, { Component, PropTypes } from 'react';

import Icon from '../tc-ui/icon';
import SectionHeading from '../tc-ui/section-heading';
import { RaisedButton } from 'material-ui';

class TempConnectionsResults extends Component {

  render() {
    const statuses = [];
    const { history, tempConnections } = this.props;

    if (tempConnections.get('emailStatuses') && tempConnections.get('emailStatuses').size) {
      tempConnections.get('emailStatuses').forEach((statusCount, statusType) => {
        if (statusCount) {
          if (statusType === 'sent') statuses.push(`we sent ${statusCount} ${statusCount === 1 ? 'invitation' : 'invitations'}`);
          if (statusType === 'resent') statuses.push(`we resent ${statusCount} invitations`);
          if (statusType === 'nowConnected') statuses.push(`you are now connected with ${statusCount} partners`);
          if (statusType === 'alreadyConnected') statuses.push(`you were already connected with ${statusCount} partners we sent invitations to`);
          if (statusType === 'error') statuses.push(`we could not send ${statusCount} invitations`);
          if (statusType === 'sentTooSoon') statuses.push(`${statusCount} of your invitations were already resent within the last week`);
          if (statusType === 'receiverIsSelf') {
            if (statusCount === 1) {
              statuses.push(`${statusCount} of your invitations was addressed to a user associated with this account`);
            } else if (statusCount > 1) {
              statuses.push(`${statusCount } of your invitations were addressed to a user associated with this account`);
            }
          }
        }
      });
    }

    let statusString = '';
    statuses.forEach((string, index) => {
      if (index === 0) {
        statusString += string.substr(0, 1).toUpperCase() + string.substr(1);
      } else {
        statusString += string;
      }
      if (index < statuses.length - 1) statusString += ', ';
      else statusString += '.';
    });

    return (
      <div>
        <Icon style={{
          height: '200px',
          width: '200px',
          fontSize: '200px',
          margin: '64px auto',
          display: 'block',
          color: '#00bcd4',
        }} className="tc-icon-paperplane"
        />
        <SectionHeading
          title="Invitations Sent"
          subtitle={'Congratulations! Your invitations have been sent. Please see the results below.'}
          style={{ marginTop: '64px' }}
        />
        <div style={{ marginBottom: '24px', textAlign: 'center' }}>
          {statusString}
        </div>
        <div style={{ textAlign: 'center' }}>
          <RaisedButton
            label="View Connections"
            type="button"
            secondary
            disableTouchRipple
            disableFocusRipple
            style={{ display: 'inline-block', minWidth: '22%', marginRight: '15px' }}
            onClick={() => history.push('/connections/invitations')}
          />
          <RaisedButton
            label="Add More Connections"
            type="button"
            primary
            disableTouchRipple
            disableFocusRipple
            style={{ display: 'inline-block', minWidth: '22%', marginLeft: '15px' }}
            onClick={() => history.push('/connections/add-connections')}
          />
        </div>
      </div>
    );
  }

}

TempConnectionsResults.propTypes = {
  history: PropTypes.object,
  tempConnections: PropTypes.object,
};

export default TempConnectionsResults;



// WEBPACK FOOTER //
// ./src/app/components/temp-connections/temp-connections-results.jsx